<template>
  <div id="app">
    <div class="editor-container">
      <div class="editor-content">
        <!-- 选择版面 -->
        <div class="ratio-selector">
          <div
            class="ratio-option"
            :class="{ active: cropRatio === '14:9' }"
            @click="cropRatio = '14:9'"
          >
            横版
          </div>
          <div
            class="ratio-option"
            :class="{ active: cropRatio === '9:14' }"
            @click="cropRatio = '9:14'"
          >
            竖版
          </div>
        </div>
        <div class="preview-area" ref="previewArea">
          <!-- 截图框 -->
          <div class="crop-overlay" :style="cropStyle"></div>
          <!-- 背景层 -->
          <div class="layer background-layer">
            <img
              :src="currentBackground"
              alt="背景"
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>
          <!-- 编辑层 -->
          <div class="layer editable-layer">
            <!-- 人像层 -->
            <div>
              <div
                v-if="portrait_img"
                class="portrait-container"
                :style="portraitContainerStyle"
                @touchstart="startPortraitDrag($event)"
              >
                <img :src="portraitImage" alt="人像" class="portrait-image" />

                <!-- 缩放控制点 -->
                <div
                  class="resize-handle"
                  :style="{ right: '-6px', bottom: '-6px' }"
                  @touchstart="startPortraitResize($event)"
                ></div>

                <!-- 旋转控制点 -->
                <div
                  class="rotate-handle"
                  :style="{ top: '-24px', right: '-12px' }"
                  @touchstart="startPortraitRotate($event)"
                >
                  ⟳
                </div>
              </div>
            </div>
            <!-- 元素层 -->
            <div>
              <div
                v-for="(decoration, index) in decorations"
                :key="index"
                class="decoration-element"
                :class="{ selected: selectedDecorationIndex === index }"
                :style="{
                  left: decoration.x + 'px',
                  top: decoration.y + 'px',
                  width: decoration.size + 'px',
                  height: decoration.size + 'px',
                  transform: `rotate(${decoration.rotation}deg)`,
                  zIndex: decoration.zIndex,
                }"
                @touchstart="startDecorationDrag($event, index)"
              >
                <img
                  :src="decoration.src"
                  alt="装饰"
                  style="width: 100%; height: 100%"
                />

                <!-- 缩放控制点 -->
                <div
                  class="resize-handle"
                  :style="{ right: '-6px', bottom: '-6px' }"
                  @touchstart="startDecorationResize($event, index)"
                ></div>

                <!-- 旋转控制点 -->
                <div
                  class="rotate-handle"
                  :style="{ top: '-24px', right: '-12px' }"
                  @touchstart="startDecorationRotate($event, index)"
                >
                  ⟳
                </div>

                <div
                  v-if="selectedDecorationIndex === index"
                  class="decoration-element-controls"
                  @touchstart="removeDecoration(index)"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 移动端标签导航 -->
        <div class="tab-navigation">
          <!-- <button
            class="tab-button"
            :class="{ active: activeTab === 'crop' }"
            @click="activeTab = 'crop'"
          >
            截图
          </button> -->
          <button
            class="tab-button"
            :class="{ active: activeTab === 'portrait' }"
            @click="activeTab = 'portrait'"
          >
            人像
          </button>
          <button
            class="tab-button"
            :class="{ active: activeTab === 'background' }"
            @click="activeTab = 'background'"
          >
            背景
          </button>
          <button
            class="tab-button"
            :class="{ active: activeTab === 'decorations' }"
            @click="activeTab = 'decorations'"
          >
            贴纸
          </button>
        </div>
        <div class="control-panel">
          <!-- 截图比例选择 -->
          <!-- <div class="control-section" v-if="activeTab === 'crop' || isDesktop">
            <h3>截图比例</h3>
            <div class="ratio-selector">
              <div
                class="ratio-option"
                :class="{ active: cropRatio === '14:9' }"
                @click="cropRatio = '14:9'"
              >
                14:9
              </div>
              <div
                class="ratio-option"
                :class="{ active: cropRatio === '9:14' }"
                @click="cropRatio = '9:14'"
              >
                9:14
              </div>
            </div>
          </div> -->
          <!-- 人像控制提示 -->
          <div
            class="control-section"
            v-if="activeTab === 'portrait' || isDesktop"
          >
            <!-- 人像抠图 -->
            <div class="portrait">
              <div v-if="!portrait_img" class="portrait_illustration_img">
                <!-- <img :src="portraitImage" alt="" /> -->
              </div>
              <div v-if="portrait_img" class="portrait_illustration_img">
                <img
                  class="portrait_illustration_img_01"
                  :src="portraitImage"
                  alt=""
                />
              </div>
              <div class="portrait_illustration" @click="selectCardface()">
                <div class="button_01">+</div>
                <div class="button_02">上传照片</div>
              </div>
            </div>
          </div>

          <!-- 背景选择 -->
          <div
            class="control-section"
            v-if="activeTab === 'background' || isDesktop"
          >
            <!-- <h5>背景选择</h5> -->
            <div class="background-options">
              <div
                v-for="(bg, index) in backgroundOptions"
                :key="index"
                class="background-option"
                :class="{ active: currentBackground === bg }"
                @click="currentBackground = bg"
              >
                <img :src="bg" alt="背景" />
              </div>
            </div>
          </div>

          <!-- 装饰元素 -->
          <div
            class="control-section"
            v-if="activeTab === 'decorations' || isDesktop"
          >
            <!-- <h3>装饰元素</h3> -->
            <div class="decoration-options">
              <div
                v-for="(decoration, index) in decorationOptions"
                :key="index"
                class="decoration-option"
                @click="addDecoration(decoration)"
              >
                <img :src="decoration" alt="装饰" />
              </div>
            </div>
            <!-- 已添加的元素 -->
            <!-- <div class="decoration-list" v-if="decorations.length > 0">
              <h4>已添加的元素</h4>
              <div
                v-for="(decoration, index) in decorations"
                :key="index"
                class="decoration-item"
                :class="{ active: selectedDecorationIndex === index }"
                @click="selectDecoration(index)"
              >
                <span>元素 {{ index + 1 }}</span>
                <div class="decoration-item-controls">
                  <button @click="removeDecoration(index)">×</button>
                </div>
              </div>
            </div> -->
          </div>

          <!-- 操作按钮 -->
          <div class="bottom_button">
            <div class="left_button" @click="back()">
              <div class="element">←</div>
              <div class="element">上一步</div>
            </div>
            <div class="right_button" @click="saveImage()">
              <div class="element">→</div>
              <div class="element">定制反面</div>
            </div>
          </div>
          <!-- <div class="action-buttons">
            <button class="btn btn-secondary" @click="resetEditor">
              重置所有
            </button>
            <button class="btn btn-primary" @click="saveImage">保存图片</button>
            <div class="status-message" v-if="saveMessage">
              {{ saveMessage }}
            </div>
          </div> -->

          <!-- 生成的图片预览 -->
          <!-- <div class="saved-image-container" v-if="savedImageUrl">
            <h3>生成的图片</h3>
            <img :src="savedImageUrl" alt="生成的图片" class="saved-image" />
            <div style="margin-top: 10px">
              <button class="btn btn-primary" @click="downloadImage">
                下载图片
              </button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 上传图片 -->
    <div v-show="false">
      <form ref="imgUploadForm">
        <input
          ref="uploadInput"
          type="file"
          accept="image/*"
          @change.prevent.stop="upload"
        />
      </form>
    </div>
    <!-- 提示 -->
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <!-- 加载 -->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">{{ prompt }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../../common/config.js");
export default {
  name: "test_ccb",
  data() {
    return {
      log: "",
      // 人像图片
      portrait_img: false,
      portraitImage: "",
      portraitX: 100,
      portraitY: 100,
      portraitWidth: "",
      portraitHeight: "",
      // portraitWidth: 200,
      // portraitHeight: 250,
      portraitRotation: 0,

      // 背景选项
      backgroundOptions: [],
      currentBackground: "",

      // 装饰元素选项
      decorationOptions: [],

      // 已添加的装饰元素
      decorations: [],
      selectedDecorationIndex: -1,

      // 截图相关
      cropRatio: "",

      // 人像控制状态
      isPortraitDragging: false,
      isPortraitResizing: false,
      isPortraitRotating: false,
      dragStartX: 0,
      dragStartY: 0,
      startPortraitX: 0,
      startPortraitY: 0,
      startPortraitWidth: 0,
      startPortraitHeight: 0,
      startPortraitRotation: 0,
      portraitCenterX: 0,
      portraitCenterY: 0,

      // 装饰元素控制状态
      decorationDragState: {
        index: -1,
        isDragging: false,
        dragOffsetX: 0,
        dragOffsetY: 0,
      },
      decorationResizeState: {
        index: -1,
        isResizing: false,
        startSize: 0,
      },
      decorationRotateState: {
        index: -1,
        isRotating: false,
        startRotation: 0,
        centerX: 0,
        centerY: 0,
      },

      // 移动端相关
      activeTab: "portrait",
      isDesktop: window.innerWidth >= 768,

      // 保存相关
      saveMessage: "",
      savedImageUrl: null,
      //
      errorMsg: "",
      // 上传图片
      pxLimit: "1075 * 686",
      imgWlimit: 1075,
      imgHlimit: 686,
      imgSizeLimit: 5 * 1024 * 1024,
      errorMsg: "",
      // 提示
      loading: false,
      prompt: "",
    };
  },
  computed: {
    // 人像容器样式
    portraitContainerStyle() {
      return {
        left: this.portraitX + "px",
        top: this.portraitY + "px",
        width: this.portraitWidth + "px",
        height: this.portraitHeight + "px",
        transform: `rotate(${this.portraitRotation}deg)`,
        transition:
          this.isPortraitDragging ||
          this.isPortraitResizing ||
          this.isPortraitRotating
            ? "none"
            : "all 0.3s",
      };
    },
    // 截图框样式
    cropStyle() {
      const previewWidth = this.$refs.previewArea
        ? this.$refs.previewArea.offsetWidth
        : 500;
      const previewHeight = this.$refs.previewArea
        ? this.$refs.previewArea.offsetHeight
        : 500;

      let width, height;

      if (this.cropRatio === "14:9") {
        width = Math.min(previewWidth, (previewHeight * 14) / 9);
        height = (width * 9) / 14;
      } else if (this.cropRatio === "9:14") {
        height = Math.min(previewHeight, (previewWidth * 14) / 9);
        width = (height * 9) / 14;
      }

      return {
        width: width + "px",
        height: height + "px",
      };
    },
  },
  mounted() {
    this.log = this.$route.params.log;
    this.getLog();
    // 监听窗口大小变化，检测是否为桌面设备
    window.addEventListener("resize", this.handleResize);
    this.cropRatio = "9:14";
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    this.portrait_img = false;
  },
  methods: {
    // 返回
    back() {
      this.$router.push({
        name: "selectTopic_ccb",
        params: {},
      });
    },
    next() {
      if (this.cropRatio == "14:9") {
        var cardOri = 0;
      } else if (this.cropRatio == "9:14") {
        var cardOri = 1;
      }
      localStorage.setItem("cardOri_ccb", cardOri);
      localStorage.setItem("targetImg_ccb", this.savedImageUrl);
      this.$router.push({
        name: "selectReverseSide_matting_ccb",
        params: {
          targetImg: this.savedImageUrl,
          cardOri: cardOri,
        },
      });
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    // 前端log保存图片 ? 暂时储存在前端
    getLog() {
      if (this.log == "girl") {
        console.log("女孩");
        this.decorationOptions = [
          "../../../static/ningbo/ningbo_project/theme_2_log_1.png",
          "../../../static/ningbo/ningbo_project/theme_2_log_2.png",
          "../../../static/ningbo/ningbo_project/theme_2_log_3.png",
          "../../../static/ningbo/ningbo_project/theme_2_log_4.png",
        ];
        this.backgroundOptions = [
          "../../../static/ningbo/ningbo_project/theme_2_background_1.png",
          "../../../static/ningbo/ningbo_project/theme_2_background_2.png",
        ];
        this.currentBackground =
          "../../../static/ningbo/ningbo_project/theme_2_background_1.png";
      } else if (this.log == "boy") {
        console.log("男孩");
        this.decorationOptions = [
          "../../../static/ningbo/ningbo_project/theme_3_log_1.png",
          "../../../static/ningbo/ningbo_project/theme_3_log_2.png",
          "../../../static/ningbo/ningbo_project/theme_3_log_3.png",
          "../../../static/ningbo/ningbo_project/theme_3_log_4.png",
        ];
        this.backgroundOptions = [
          "../../../static/ningbo/ningbo_project/theme_3_background_1.png",
          "../../../static/ningbo/ningbo_project/theme_3_background_2.png",
        ];
        this.currentBackground =
          "../../../static/ningbo/ningbo_project/theme_3_background_1.png";
      } else if (this.log == "lovers") {
        console.log("情侣");
        this.decorationOptions = [
          "../../../static/ningbo/ningbo_project/theme_1_log_1.png",
          "../../../static/ningbo/ningbo_project/theme_1_log_2.png",
          "../../../static/ningbo/ningbo_project/theme_1_log_3.png",
          "../../../static/ningbo/ningbo_project/theme_1_log_4.png",
        ];
        this.backgroundOptions = [
          "../../../static/ningbo/ningbo_project/theme_1_background_1.png",
          "../../../static/ningbo/ningbo_project/theme_1_background_2.png",
        ];
        this.currentBackground =
          "../../../static/ningbo/ningbo_project/theme_1_background_2.png";
      } else if (this.log == "cute") {
        console.log("萌宠");
        this.decorationOptions = [
          "../../../static/ningbo/ningbo_project/theme_4_log_1.png",
          "../../../static/ningbo/ningbo_project/theme_4_log_2.png",
          "../../../static/ningbo/ningbo_project/theme_4_log_3.png",
          "../../../static/ningbo/ningbo_project/theme_4_log_4.png",
        ];
        this.backgroundOptions = [
          "../../../static/ningbo/ningbo_project/theme_4_background_1.png",
          "../../../static/ningbo/ningbo_project/theme_4_background_2.png",
        ];
        this.currentBackground =
          "../../../static/ningbo/ningbo_project/theme_4_background_1.png";
      }
    },
    // 上传图片
    selectCardface: function () {
      this.resetUpload();
      this.$refs.uploadInput.click();
      // var that = this;
      // wx.chooseImage({
      //   count: 1, // 默认9
      //   sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      //   sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      //   success: function(res) {
      //     console.log(res);
      //     var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
      //     var faceImgPath = localIds[0];
      //     console.log('imgPath:' + faceImgPath);
      //     that.checkImg(faceImgPath);
      //   },
      // });
    },
    resetUpload: function () {
      var form = this.$refs.imgUploadForm;
      console.log(form);
      form.reset();
    },
    upload: function (event) {
      var that = this;
      console.log(event);
      let file = event.target.files[0];
      // 压缩图片
      let fileSize = file.size;
      console.log(file);
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      }
      console.log("url--->", url);
      if (fileSize > this.imgSizeLimit) {
        that.errorMsg = "图片大小不能超过5MB";
        that.showErrorMsg();
        that.resetUpload();
      } else {
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function () {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          that.portraitWidth = image.width / 10;
          that.portraitHeight = image.height / 10;
          image.onload = null; // 避免重复加载
          console.log("图片宽高:" + w + "*" + h);
          console.log("图片大小:" + fileSize / 1024 + "KB");
          if (w >= that.imgWlimit && h >= that.imgHlimit) {
            // 抠图
            // that.getSmart_cutouts(url);
            console.log("url--->", url);
            that.compressBlobImage(url, 0.4).then((compressedBlobUrl) => {
              console.log("压缩后的blob URL:", compressedBlobUrl);
              // 使用压缩后的URL
              that.getSmart_cutouts(compressedBlobUrl);
            });
          } else {
            that.errorMsg = "图片像素不符合要求，图片的像素：" + w + "*" + h;
            that.showErrorMsg();
            that.resetUpload();
          }
        };
      }
    },

    // 方法1：使用Canvas压缩图片
    compressBlobImage(blobUrl, quality = 0.5, maxWidth = 800) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
          const canvas = document.createElement("canvas");
          let { width, height } = img;

          // 按比例缩放
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // 压缩为blob
          canvas.toBlob(
            (compressedBlob) => {
              const compressedBlobUrl = URL.createObjectURL(compressedBlob);
              resolve(compressedBlobUrl);
            },
            "image/jpeg",
            quality
          );
        };

        img.onerror = reject;
        img.src = blobUrl;
      });
    },

    // 抠图接口
    getSmart_cutouts(url) {
      this.prompt = "抠图中...";
      this.showLoading();
      let that = this;
      this.imgToDataUrl(url, (dataUrl) => {
        let param = {
          image: that.removeBase64Prefix(dataUrl),
          method: "auto",
        };
        axios
          .post(config.config_ccb.smart_cutouts, param)
          .then(function (response) {
            console.log(response);
            let data = response.data;
            if (data.code == 200) {
              let image = data.data.image;
              that.portrait_img = true;
              that.portraitImage = that.removeBase64ToURL(image);
              that.hideLoading();
            } else {
              that.hideLoading();
              console.log(data);
            }
          })
          .catch(function (error) {
            console.log(error);
            this.hideLoading();
          });
      });
    },
    // 去掉base前缀
    removeBase64Prefix(base64Str) {
      const commaIndex = base64Str.indexOf(",");
      return base64Str.substring(commaIndex + 1);
    },
    // 添加base前缀
    removeBase64ToURL(base64String) {
      let base64 = "data:image/png;base64," + base64String;
      return base64;
    },
    // base64转url
    imgToDataUrl: function (url, callback) {
      var Img = new Image(),
        dataURL = "";
      Img.src = url;
      Img.onload = function () {
        //要先确保图片完整获取到，这是个异步事件
        var canvas = document.createElement("canvas"), //创建canvas元素
          width = Img.width, //确保canvas的尺寸和图片一样
          height = Img.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(Img, 0, 0, width, height); //将图片绘制到canvas中
        dataURL = canvas.toDataURL("image/png"); //转换图片为dataURL
        callback(dataURL);
      };
    },

    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    // 处理窗口大小变化
    handleResize() {
      this.isDesktop = window.innerWidth >= 768;
    },
    handleOk: function (bvModalEvt) {},
    // 添加装饰元素
    addDecoration(src) {
      this.decorations.push({
        src: src,
        x: 100,
        y: 100,
        size: 80,
        rotation: 0,
        zIndex: 10 + this.decorations.length,
      });
      this.selectedDecorationIndex = this.decorations.length - 1;
    },

    // 选择装饰元素
    selectDecoration(index) {
      this.selectedDecorationIndex = index;
    },

    // 移除装饰元素
    removeDecoration(index) {
      console.log("移除装饰元素");
      this.decorations.splice(index, 1);
      if (this.selectedDecorationIndex === index) {
        this.selectedDecorationIndex = -1;
      } else if (this.selectedDecorationIndex > index) {
        this.selectedDecorationIndex--;
      }
    },

    // 开始拖拽装饰元素
    startDecorationDrag(event, index) {
      event.stopPropagation();
      event.preventDefault();
      this.selectedDecorationIndex = index;
      this.decorationDragState.index = index;
      this.decorationDragState.isDragging = true;
      const clientX = event.type.includes("touch")
        ? event.touches[0].clientX
        : event.clientX;
      const clientY = event.type.includes("touch")
        ? event.touches[0].clientY
        : event.clientY;
      const rect = this.$refs.previewArea.getBoundingClientRect();
      this.decorationDragState.dragOffsetX =
        clientX - rect.left - this.decorations[index].x;
      this.decorationDragState.dragOffsetY =
        clientY - rect.top - this.decorations[index].y;

      document.addEventListener("touchmove", this.onDecorationDrag);
      document.addEventListener("touchend", this.stopDecorationDrag);
    },
    // 拖拽装饰元素中
    onDecorationDrag(event) {
      if (
        !this.decorationDragState.isDragging ||
        this.decorationDragState.index === -1
      )
        return;
      const clientX = event.type.includes("touch")
        ? event.touches[0].clientX
        : event.clientX;
      const clientY = event.type.includes("touch")
        ? event.touches[0].clientY
        : event.clientY;

      const rect = this.$refs.previewArea.getBoundingClientRect();
      const x = clientX - rect.left - this.decorationDragState.dragOffsetX;
      const y = clientY - rect.top - this.decorationDragState.dragOffsetY;

      // 限制在预览区域内
      const maxX =
        rect.width - this.decorations[this.decorationDragState.index].size;
      const maxY =
        rect.height - this.decorations[this.decorationDragState.index].size;

      this.decorations[this.decorationDragState.index].x = Math.max(
        0,
        Math.min(x, maxX)
      );
      this.decorations[this.decorationDragState.index].y = Math.max(
        0,
        Math.min(y, maxY)
      );
    },
    // 停止拖拽装饰元素
    stopDecorationDrag() {
      this.decorationDragState.isDragging = false;
      this.decorationDragState.index = -1;
      document.removeEventListener("touchmove", this.onDecorationDrag);
      document.removeEventListener("touchend", this.stopDecorationDrag);
    },
    // 开始缩放装饰元素
    startDecorationResize(event, index) {
      event.stopPropagation();
      event.preventDefault();
      this.selectedDecorationIndex = index;
      this.decorationResizeState.index = index;
      this.decorationResizeState.isResizing = true;
      this.decorationResizeState.startSize = this.decorations[index].size;
      const clientX = event.type.includes("touch")
        ? event.touches[0].clientX
        : event.clientX;
      const clientY = event.type.includes("touch")
        ? event.touches[0].clientY
        : event.clientY;
      this.dragStartX = clientX;
      this.dragStartY = clientY;
      document.addEventListener("touchmove", this.onDecorationResize);
      document.addEventListener("touchend", this.stopDecorationResize);
    },

    // 缩放装饰元素中
    onDecorationResize(event) {
      if (
        !this.decorationResizeState.isResizing ||
        this.decorationResizeState.index === -1
      )
        return;

      const clientX = event.type.includes("touch")
        ? event.touches[0].clientX
        : event.clientX;
      const clientY = event.type.includes("touch")
        ? event.touches[0].clientY
        : event.clientY;

      const deltaX = clientX - this.dragStartX;
      const deltaY = clientY - this.dragStartY;

      // 计算缩放比例
      const scaleFactor = 1 + (deltaX + deltaY) / 100;

      // 更新装饰元素大小
      this.decorations[this.decorationResizeState.index].size = Math.max(
        20,
        Math.min(200, this.decorationResizeState.startSize * scaleFactor)
      );
    },

    // 停止缩放装饰元素
    stopDecorationResize() {
      this.decorationResizeState.isResizing = false;
      this.decorationResizeState.index = -1;
      document.removeEventListener("touchmove", this.onDecorationResize);
      document.removeEventListener("touchend", this.stopDecorationResize);
    },

    // 开始旋转装饰元素
    startDecorationRotate(event, index) {
      event.stopPropagation();
      event.preventDefault();
      this.selectedDecorationIndex = index;
      this.decorationRotateState.index = index;
      this.decorationRotateState.isRotating = true;
      this.decorationRotateState.startRotation =
        this.decorations[index].rotation;

      const clientX = event.type.includes("touch")
        ? event.touches[0].clientX
        : event.clientX;
      const clientY = event.type.includes("touch")
        ? event.touches[0].clientY
        : event.clientY;

      // 计算装饰元素中心点
      const rect = this.$refs.previewArea.getBoundingClientRect();
      this.decorationRotateState.centerX =
        rect.left +
        this.decorations[index].x +
        this.decorations[index].size / 2;
      this.decorationRotateState.centerY =
        rect.top + this.decorations[index].y + this.decorations[index].size / 2;

      // 计算初始角度
      this.decorationRotateState.initialAngle = Math.atan2(
        clientY - this.decorationRotateState.centerY,
        clientX - this.decorationRotateState.centerX
      );
      document.addEventListener("touchmove", this.onDecorationRotate);
      document.addEventListener("touchend", this.stopDecorationRotate);
    },

    // 旋转装饰元素中
    onDecorationRotate(event) {
      if (
        !this.decorationRotateState.isRotating ||
        this.decorationRotateState.index === -1
      )
        return;

      const clientX = event.type.includes("touch")
        ? event.touches[0].clientX
        : event.clientX;
      const clientY = event.type.includes("touch")
        ? event.touches[0].clientY
        : event.clientY;

      // 计算当前角度
      const currentAngle = Math.atan2(
        clientY - this.decorationRotateState.centerY,
        clientX - this.decorationRotateState.centerX
      );

      // 计算旋转角度差并转换为度数
      const angleDiff =
        (currentAngle - this.decorationRotateState.initialAngle) *
        (180 / Math.PI);

      // 更新装饰元素旋转角度
      this.decorations[this.decorationRotateState.index].rotation =
        (this.decorationRotateState.startRotation + angleDiff) % 360;
    },

    // 停止旋转装饰元素
    stopDecorationRotate() {
      this.decorationRotateState.isRotating = false;
      this.decorationRotateState.index = -1;
      document.removeEventListener("touchmove", this.onDecorationRotate);
      document.removeEventListener("touchend", this.stopDecorationRotate);
    },

    // 装饰元素触摸开始
    onDecorationTouchStart(event, index) {
      event.preventDefault();
      event.stopPropagation();
      this.selectedDecorationIndex = index;
    },

    // 开始拖拽人像
    startPortraitDrag(event) {
      // 阻止默认行为，防止图片被拖动
      event.stopPropagation();
      event.preventDefault();

      this.isPortraitDragging = true;
      this.dragStartX = event.clientX || event.touches[0].clientX;
      this.dragStartY = event.clientY || event.touches[0].clientY;
      this.startPortraitX = this.portraitX;
      this.startPortraitY = this.portraitY;

      document.addEventListener("touchmove", this.onPortraitDrag);
      document.addEventListener("touchend", this.stopPortraitDrag);
    },

    // 拖拽人像中
    onPortraitDrag(event) {
      if (!this.isPortraitDragging) return;

      const clientX =
        event.clientX || (event.touches && event.touches[0].clientX);
      const clientY =
        event.clientY || (event.touches && event.touches[0].clientY);

      if (!clientX || !clientY) return;

      const deltaX = clientX - this.dragStartX;
      const deltaY = clientY - this.dragStartY;

      // 移动人像
      this.portraitX = this.startPortraitX + deltaX;
      this.portraitY = this.startPortraitY + deltaY;
    },

    // 停止拖拽人像
    stopPortraitDrag() {
      this.isPortraitDragging = false;
      document.removeEventListener("touchmove", this.onPortraitDrag);
      document.removeEventListener("touchend", this.stopPortraitDrag);
    },

    // 开始缩放人像
    startPortraitResize(event) {
      event.stopPropagation();
      event.preventDefault();
      this.isPortraitResizing = true;
      this.startPortraitWidth = this.portraitWidth;
      this.startPortraitHeight = this.portraitHeight;

      this.dragStartX = event.clientX || event.touches[0].clientX;
      this.dragStartY = event.clientY || event.touches[0].clientY;

      document.addEventListener("touchmove", this.onPortraitResize);
      document.addEventListener("touchend", this.stopPortraitResize);
    },

    // 缩放人像中
    onPortraitResize(event) {
      if (!this.isPortraitResizing) return;

      const clientX =
        event.clientX || (event.touches && event.touches[0].clientX);
      const clientY =
        event.clientY || (event.touches && event.touches[0].clientY);

      if (!clientX || !clientY) return;

      const deltaX = clientX - this.dragStartX;
      const deltaY = clientY - this.dragStartY;

      // 计算缩放比例
      const scaleFactor = 1 + (deltaX + deltaY) / 100;

      // 更新人像大小
      this.portraitWidth = Math.max(
        50,
        Math.min(500, this.startPortraitWidth * scaleFactor)
      );
      this.portraitHeight = Math.max(
        62.5,
        Math.min(625, this.startPortraitHeight * scaleFactor)
      );
    },

    // 停止缩放人像
    stopPortraitResize() {
      this.isPortraitResizing = false;
      document.removeEventListener("touchmove", this.onPortraitResize);
      document.removeEventListener("touchend", this.stopPortraitResize);
    },

    // 开始旋转人像
    startPortraitRotate(event) {
      event.stopPropagation();
      event.preventDefault();
      this.isPortraitRotating = true;
      this.startPortraitRotation = this.portraitRotation;

      this.dragStartX = event.clientX || event.touches[0].clientX;
      this.dragStartY = event.clientY || event.touches[0].clientY;

      // 计算人像中心点
      const rect = this.$refs.previewArea.getBoundingClientRect();
      this.portraitCenterX =
        rect.left + this.portraitX + this.portraitWidth / 2;
      this.portraitCenterY =
        rect.top + this.portraitY + this.portraitHeight / 2;

      // 计算初始角度
      this.initialAngle = Math.atan2(
        this.dragStartY - this.portraitCenterY,
        this.dragStartX - this.portraitCenterX
      );

      document.addEventListener("touchmove", this.onPortraitRotate);
      document.addEventListener("touchend", this.stopPortraitRotate);
    },

    // 旋转人像中
    onPortraitRotate(event) {
      if (!this.isPortraitRotating) return;

      const clientX =
        event.clientX || (event.touches && event.touches[0].clientX);
      const clientY =
        event.clientY || (event.touches && event.touches[0].clientY);

      if (!clientX || !clientY) return;

      // 计算当前角度
      const currentAngle = Math.atan2(
        clientY - this.portraitCenterY,
        clientX - this.portraitCenterX
      );

      // 计算旋转角度差并转换为度数
      const angleDiff = (currentAngle - this.initialAngle) * (180 / Math.PI);

      // 更新人像旋转角度
      this.portraitRotation = (this.startPortraitRotation + angleDiff) % 360;
    },

    // 停止旋转人像
    stopPortraitRotate() {
      this.isPortraitRotating = false;
      document.removeEventListener("touchmove", this.onPortraitRotate);
      document.removeEventListener("touchend", this.stopPortraitRotate);
    },

    // 人像触摸开始
    onPortraitTouchStart(event) {
      event.preventDefault();
      event.stopPropagation();
    },

    // 重置人像位置、大小和旋转
    resetPortrait() {
      this.portraitX = 100;
      this.portraitY = 100;
      this.portraitWidth = 200;
      this.portraitHeight = 250;
      this.portraitRotation = 0;
    },

    // 重置编辑器
    resetEditor() {
      this.resetPortrait();
      this.currentBackground = this.backgroundOptions[0];
      this.decorations = [];
      this.selectedDecorationIndex = -1;
      this.cropRatio = "14:9";
      this.saveMessage = "";
      this.savedImageUrl = null;
    },

    // 保存图片 - 使用Canvas生成图片
    async saveImage() {
      this.prompt = "图片生成...";
      this.showLoading();
      try {
        // 创建Canvas元素
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 获取截图框的尺寸
        const cropRect = this.cropStyle;
        const cropWidth = parseInt(cropRect.width);
        const cropHeight = parseInt(cropRect.height);

        // 设置Canvas尺寸为截图框尺寸
        canvas.width = cropWidth;
        canvas.height = cropHeight;

        // 计算截图框在预览区域中的位置
        const previewRect = this.$refs.previewArea.getBoundingClientRect();
        const cropX = (previewRect.width - cropWidth) / 2;
        const cropY = (previewRect.height - cropHeight) / 2;

        // 绘制背景
        await this.drawBackground(ctx, cropWidth, cropHeight);

        // 绘制人像
        await this.drawPortrait(ctx, cropX, cropY);

        // 绘制装饰元素
        await this.drawDecorations(ctx, cropX, cropY, cropWidth, cropHeight);

        // 将Canvas转换为Data URL
        this.savedImageUrl = canvas.toDataURL("image/png");
        console.log("生成图片--->", this.savedImageUrl);
        this.hideLoading();
        this.next();
        // 3秒后清除消息
        console.log("图片已生成并保存");
        console.log("当前设置:");
        console.log(
          "- 人像位置:",
          `(${this.portraitX.toFixed(0)}, ${this.portraitY.toFixed(0)})`
        );
        console.log(
          "- 人像大小:",
          `${this.portraitWidth.toFixed(0)}×${this.portraitHeight.toFixed(0)}`
        );
        console.log("- 人像旋转:", this.portraitRotation.toFixed(0) + "°");
        console.log("- 背景:", this.currentBackground);
        console.log("- 截图比例:", this.cropRatio);
        console.log("- 装饰元素数量:", this.decorations.length);
      } catch (error) {
        this.hideLoading();
        this.saveMessage = "生成图片时出错: " + error.message;
        console.error("生成图片时出错:", error);
      }
    },

    // 绘制背景
    drawBackground(ctx, cropWidth, cropHeight) {
      return new Promise((resolve, reject) => {
        const backgroundImg = new Image();
        backgroundImg.crossOrigin = "anonymous";
        backgroundImg.onload = () => {
          // 计算背景在截图框中的位置和尺寸
          const bgAspectRatio = backgroundImg.width / backgroundImg.height;
          const cropAspectRatio = cropWidth / cropHeight;

          let bgDrawWidth, bgDrawHeight, bgDrawX, bgDrawY;

          if (bgAspectRatio > cropAspectRatio) {
            // 背景比截图框宽，按高度适配
            bgDrawHeight = cropHeight;
            bgDrawWidth = bgDrawHeight * bgAspectRatio;
            bgDrawX = (cropWidth - bgDrawWidth) / 2;
            bgDrawY = 0;
          } else {
            // 背景比截图框高，按宽度适配
            bgDrawWidth = cropWidth;
            bgDrawHeight = bgDrawWidth / bgAspectRatio;
            bgDrawX = 0;
            bgDrawY = (cropHeight - bgDrawHeight) / 2;
          }

          ctx.drawImage(
            backgroundImg,
            bgDrawX,
            bgDrawY,
            bgDrawWidth,
            bgDrawHeight
          );
          resolve();
        };

        backgroundImg.onerror = () => {
          reject(new Error("背景图片加载失败"));
        };

        backgroundImg.src = this.currentBackground;
      });
    },

    // 绘制人像
    drawPortrait(ctx, cropX, cropY) {
      return new Promise((resolve, reject) => {
        const portraitImg = new Image();
        portraitImg.crossOrigin = "anonymous";
        portraitImg.onload = () => {
          // 保存当前Canvas状态
          ctx.save();

          // 计算人像在截图框中的位置
          const portraitXInCrop = this.portraitX - cropX;
          const portraitYInCrop = this.portraitY - cropY;

          // 移动到人像中心点
          ctx.translate(
            portraitXInCrop + this.portraitWidth / 2,
            portraitYInCrop + this.portraitHeight / 2
          );

          // 旋转Canvas
          ctx.rotate((this.portraitRotation * Math.PI) / 180);

          // 绘制人像（注意坐标已偏移到中心点）
          ctx.drawImage(
            portraitImg,
            -this.portraitWidth / 2,
            -this.portraitHeight / 2,
            this.portraitWidth,
            this.portraitHeight
          );

          // 恢复Canvas状态
          ctx.restore();
          resolve();
        };

        portraitImg.onerror = () => {
          reject(new Error("人像图片加载失败"));
          // 上传人像进行抠图提示
          this.errorMsg = "请上传图片，进行抠图";
          this.showErrorMsg();
        };

        portraitImg.src = this.portraitImage;
      });
    },

    // 绘制装饰元素
    drawDecorations(ctx, cropX, cropY, cropWidth, cropHeight) {
      // 如果没有装饰元素，直接返回
      if (this.decorations.length === 0) {
        return Promise.resolve();
      }

      // 创建所有装饰元素的绘制Promise
      const decorationPromises = this.decorations.map((decoration) => {
        return new Promise((resolve, reject) => {
          // 计算装饰元素在截图框中的位置
          const decXInCrop = decoration.x - cropX;
          const decYInCrop = decoration.y - cropY;

          // 如果装饰元素不在截图框内，则不绘制
          if (
            decXInCrop + decoration.size < 0 ||
            decXInCrop > cropWidth ||
            decYInCrop + decoration.size < 0 ||
            decYInCrop > cropHeight
          ) {
            resolve();
            return;
          }

          const decImg = new Image();
          decImg.crossOrigin = "anonymous";
          decImg.onload = () => {
            // 保存当前Canvas状态
            ctx.save();

            // 移动到装饰元素中心点
            ctx.translate(
              decXInCrop + decoration.size / 2,
              decYInCrop + decoration.size / 2
            );

            // 旋转Canvas
            ctx.rotate((decoration.rotation * Math.PI) / 180);

            // 绘制装饰元素
            ctx.drawImage(
              decImg,
              -decoration.size / 2,
              -decoration.size / 2,
              decoration.size,
              decoration.size
            );

            // 恢复Canvas状态
            ctx.restore();
            resolve();
          };

          decImg.onerror = () => {
            console.error("装饰元素图片加载失败:", decoration.src);
            resolve(); // 即使单个装饰元素加载失败，也不影响其他元素
          };

          decImg.src = decoration.src;
        });
      });

      // 等待所有装饰元素绘制完成
      return Promise.all(decorationPromises);
    },

    // 下载生成的图片
    // downloadImage() {
    //   if (!this.savedImageUrl) return;
    //   const link = document.createElement("a");
    //   link.href = this.savedImageUrl;
    //   link.download = "edited-image.png";
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f7fa;
  color: #333;
  padding: 10px;
  overflow-x: hidden;
}
.editor-container {
  max-width: 100%;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.editor-header {
  padding: 15px;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  text-align: center;
}
.editor-header h1 {
  font-size: 20px;
  margin-bottom: 8px;
}
.editor-header p {
  font-size: 14px;
}
.editor-content {
  display: flex;
  flex-direction: column;
  padding: 15px;
}
@media (min-width: 768px) {
  .editor-content {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.preview-area {
  width: 100%;
  height: 60vh;
  min-height: 350px;
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  margin-bottom: 15px;
  touch-action: none;
  user-select: none;
}
@media (min-width: 768px) {
  .preview-area {
    flex: 1;
    min-width: 500px;
    height: 500px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
}
.preview-area .layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.preview-area .background-layer {
  z-index: 1;
}
.preview-area .editable-layer {
  z-index: 2;
}

.control-panel {
  width: 100%;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
}
@media (min-width: 768px) {
  .control-panel {
    width: 300px;
  }
}
.control-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}
.portrait {
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
}
.portrait_illustration {
  width: 5rem;
  height: 5rem;
  background-color: #dee2e6;
  border: 1px solid #0066cc;
  border-radius: 0.6rem;
  text-align: center;
}
.portrait_illustration_img {
  width: 5rem;
  height: 5rem;
  background-color: #dee2e6;
  border: 1px solid #0066cc;
  border-radius: 0.6rem;
  margin-right: 1rem;
}
.portrait_illustration_img_01 {
  width: 4.8rem;
  height: 4.8rem;
  margin: 0 auto;
}
.button_01 {
  font-size: 2rem;
  color: #0066cc;
}
.button_02 {
  font-size: 0.8rem;
  font-weight: 100;
  color: #0066cc;
}
.control-section .control-section h3 {
  margin-bottom: 12px;
  color: #495057;
  font-size: 16px;
}

.background-options {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  justify-content: center;
}
.background-option {
  width: 70px;
  height: 70px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s;
}
@media (min-width: 768px) {
  .background-option {
    width: 80px;
    height: 80px;
  }
}
.background-option.active {
  border-color: #2575fc;
  box-shadow: 0 0 8px rgba(37, 117, 252, 0.5);
}
.background-option img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.decoration-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  justify-content: space-between;
}
.decoration-option {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #dee2e6;
  transition: all 0.3s;
}
@media (min-width: 768px) {
  .decoration-option {
    width: 60px;
    height: 60px;
  }
}
.decoration-option:hover {
  transform: scale(1.05);
}
.decoration-option img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.decoration-list {
  margin-top: 15px;
}
.decoration-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  background: white;
  border-radius: 6px;
  margin-bottom: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  font-size: 14px;
}
.decoration-item-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.decoration-item-controls button {
  padding: 4px 6px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
}
.decoration-item-controls button:hover {
  background: #e9ecef;
}
.bottom_button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .left_button {
    width: 40%;
    height: 2.4rem;
    padding-top: 0.4rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    border: 1px solid #093695;
    border-radius: 1.2rem;
    .element {
      font-weight: 500;
      font-size: 1rem;
      color: #093695;
      font-family: "黑体", "Microsoft YaHei", sans-serif;
    }
  }
  .right_button {
    width: 50%;
    height: 2.4rem;
    padding-top: 0.4rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    // border: 1px solid #023bb6;
    background: linear-gradient(to right, #093695, #0d1632);
    border-radius: 1.2rem;
    .element {
      font-weight: 500;
      font-size: 1rem;
      color: white;
      font-family: "黑体", "Microsoft YaHei", sans-serif;
    }
  }
}
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 15px;
}
.btn {
  padding: 12px 18px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}
.btn-primary {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
}
.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(37, 117, 252, 0.4);
}
.btn-secondary {
  background: #6c757d;
  color: white;
}
.btn-secondary:hover {
  background: #5a6268;
}
.decoration-element {
  position: absolute;
  cursor: move;
  z-index: 10;
}
.decoration-element.selected {
  outline: 2px dashed #2575fc;
}
.decoration-element-controls {
  position: absolute;
  width: 18px;
  height: 18px;
  top: -10px;
  left: 0;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2575fc;
  color: white;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 20;
}

.decoration-element-controls button:hover {
  background: #2575fc;
}
.ratio-selector {
  width: 100%;
  display: flex;
  margin-bottom: 1rem;
  padding-left: 75%;
}
.ratio-option {
  width: 3rem;
  height: 1.6rem;
  padding-top: 0.25rem;
  text-align: center;
  background: #e9ecef;
  border-radius: 0.3rem;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.8rem;
}
.ratio-option.active {
  background: #2575fc;
  color: white;
}
.crop-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px dashed #2575fc;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  z-index: 100;
  pointer-events: none;
}
.status-message {
  margin-top: 12px;
  padding: 8px;
  background: #e7f3ff;
  border-radius: 4px;
  color: #0066cc;
  text-align: center;
  font-size: 13px;
}
.control-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #6c757d;
  text-align: center;
  line-height: 1.4;
}
.portrait-container {
  position: absolute;
  cursor: move;
  transition: transform 0.1s;
  user-select: none;
  -webkit-user-select: none;
  transform-origin: center;
  border: 2px dashed #0066cc;
}

.portrait-container:active {
  cursor: grabbing;
}
.portrait-image {
  width: 100%;
  height: 100%;
  display: block;
}
.transform-controls {
  position: absolute;
  bottom: 8px;
  left: 8px;
  background: rgba(255, 255, 255, 0.85);
  padding: 8px;
  border-radius: 6px;
  font-size: 11px;
  max-width: 80%;
  z-index: 10;
}
@media (min-width: 768px) {
  .transform-controls {
    font-size: 12px;
    max-width: none;
  }
}
.portrait-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.portrait-control-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: #2575fc;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s;
}
.portrait-control-btn:hover {
  background: #1c68e0;
  transform: scale(1.1);
}
@media (max-width: 767px) {
  .portrait-controls {
    top: auto;
    bottom: 10px;
    right: 10px;
    flex-direction: row;
  }
}
.tab-navigation {
  display: flex;
  margin-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}
.tab-button {
  flex: 1;
  padding: 10px;
  text-align: center;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}
.tab-button.active {
  border-bottom-color: #2575fc;
  color: #2575fc;
  font-weight: 600;
}
@media (min-width: 768px) {
  .tab-navigation {
    display: none;
  }
}
.saved-image-container {
  margin-top: 20px;
  text-align: center;
}
.saved-image {
  max-width: 100%;
  max-height: 300px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
/* 边界控制点样式 */
.resize-handle {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #2575fc;
  border: 2px solid white;
  border-radius: 50%;
  cursor: nwse-resize;
  z-index: 20;
}
.rotate-handle {
  position: absolute;
  width: 16px;
  height: 16px;
  color: #2575fc;
  font-weight: 900;
  border-radius: 50%;
  cursor: grab;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/CCB_demo/Matting/Matting.vue